
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import publicacion from './utiles-detalles-publicacion.vue';
    import conversacion from './utiles-detalles-conversacion.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            conversacion,
            publicacion
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Modo() { return this.Controlador.Vista.SubModo; }
        public set Modo( x: string ) { this.Controlador.Vista.SubModo = x; }

        public get Publicacion()
        {
            return this.Controlador.Seleccionada.Publicacion;
        }

        mounted()
        {
            this.Controlador.BarraLateralWidth = 615;
        }

        Cerrar()
        {
            this.Controlador.Vista.Modo = 'respuestas';
        }
    }
